import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivateChild {
  constructor(public authService: AuthService, public router: Router) { }

  canActivateChild(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    // A versão anterior retornava `undefined` SINCRONAMENTE — o resultado
    // ficava preso dentro do `.subscribe()` (nunca chega no return da
    // função). Angular interpreta undefined como "não autorizado" e
    // bloqueia a navegação silenciosamente: URL muda, router-outlet fica
    // vazio, página em branco sem erro.
    //
    // Fix: retorna o próprio Observable mapeado para boolean/UrlTree, do
    // jeito que o contrato do CanActivateChild espera. Se a checagem
    // falhar (erro de rede/auth), redireciona p/ '/' via UrlTree.
    return this.authService.directUserIsAdmin().pipe(
      map(isAdmin => isAdmin === true ? true : this.router.parseUrl('/')),
      catchError(() => of(this.router.parseUrl('/')))
    );
  }
}
